/**
 * Created by shiyonggao on 2019/2/25.
 */

import axios from "axios";

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    pushTopicGroupList: [],
    planSchedulesList: [],
    topicGroupId:''
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_PUSH_TOPIC_GROUP_LIST({state, commit, dispatch, rootState}, args) {

        let push_games_code_push_topic_group_url = rootState.$config.api.push_games_code_push_topic_group_url;
        push_games_code_push_topic_group_url = push_games_code_push_topic_group_url.replace('{game_code}',args.game_code);

        rootState.$helper.request.get(push_games_code_push_topic_group_url, {limit:1000,...args})
            .then((res)=>{
                commit('_updatePushTopicGroupList', res.data);
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    GET_PLAN_SCHEDULES_LIST({state, commit, dispatch, rootState}, args) {

        let push_schedules_list_url = rootState.$config.api.push_schedules_list_url;
        push_schedules_list_url = push_schedules_list_url.replace('{game_code}',args.game_code);

        rootState.$helper.request.get(push_schedules_list_url, args)
            .then((res)=>{
                commit('_updatePlanSchedulesList', res.data);
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });


    },
    DELETE_SCHEDULES_BY_ID({state, commit, dispatch, rootState}, args) {

        let push_delete_edit_schedules_by_id_url = rootState.$config.api.push_delete_edit_schedules_by_id_url;
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{game_code}',args.game_code);
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{schedule_id}',args.schedule_id);

        rootState.$helper.request.delete(push_delete_edit_schedules_by_id_url, args)
            .then((res)=>{
                dispatch('GET_PLAN_SCHEDULES_LIST',{game_code: args.game_code,topic_group_id:args.topic_group_id,status:5})
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });


    },
    EDIT_PLAN_SCHEDULES({state, commit, dispatch, rootState}, args) {

        let push_delete_edit_schedules_by_id_url = rootState.$config.api.push_delete_edit_schedules_by_id_url;
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{game_code}',args.game_code);
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{schedule_id}',args.schedule_id);

        rootState.$helper.request.put(push_delete_edit_schedules_by_id_url, args)
            .then((res)=>{
                dispatch('GET_PLAN_SCHEDULES_LIST',{game_code: args.game_code,topic_group_id:args.topic_group_id,status:5})

            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {
    GET_DEMO_GETTER(state, getters){
        let data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;

    },

    getDemoGetterOthr(state, getters){
        return[{id: 4, data: 'aata4'}]
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _updatePushTopicGroupList(state, args){
        state.pushTopicGroupList = args.topic_groups;
    },
    _updatePlanSchedulesList(state, args) {
        state.planSchedulesList = args.schedules;
    },
    _updateTopicGroupId(state, args){
        state.topicGroupId = args;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/push/PushPlanDetail.js